/**
 * Returns an extension starting with a dot and in lowercase (.xxx).
 */
export function get_file_extension(url, extension) {
    const file_path = extension ? url + "." + extension : url;
    // Match first string preceded by '.', containing none of characters '.?#', and followed by string starting with '?' or '#', or nothing
    const file_extension = file_path.match(/\.([^.?#]+)($|\?|#)/);
    return (file_extension ? `.${file_extension[1].toLowerCase()}` : ".");
}
//# sourceMappingURL=FilePath.js.map